// dependencies
import React from 'react';

const NoMatch = () => {
   return (
      <div>
         <h1
            style={{
               textAlign: 'center',
               fontSize: '40px',
               marginTop: '50px',
               color: '#a93737',
            }}
         >
            Sorry! 404 Page Not Found! 🚩
         </h1>
      </div>
   );
};

export default NoMatch;
